// types
import { type ModuleType as Login } from "./_definitions"
import { type State } from "../../types"

export const loginSelector = (state: State): Login | null => state.login
